export default __webpack_public_path__ + "c7d31c76f942a352c1a1adfbd278318f.riv";